import React from "react";
import PillsDynamic from "../PillsDynamic";
import { RecordFill } from "react-bootstrap-icons";
import dayjs from 'dayjs';

const TableConfig = {
     truncateCellStyle: (val) => {
        if (!val) return '';
        return val.length > 18 ? val.slice(0, 18) + '…' : val;
    },

    'USERLIST_SETTINGS_CONFIG': () => {
        let secLevelColor = {
            '1': 'b-w-500',
            '2': 'blue-600',
            '3': 'blue-400',
            '4': 'green-300',
            '5': 'green-500',
            '6': 'orange-500'
        }

        return [
            {
                header: 'Name',
                sort: true,
                column: 'displayName',
                className: 'user-column p-b vertical-align truncate-cell',
                accessor: row  => {
                    return (
                        <div>{TableConfig.truncateCellStyle(row.displayName)}</div>
                    );
                }
            },
            {
                header: 'Email',
                sort: true,
                column: 'mail',
                className: 'email-column p-b vertical-align truncate-cell',
                accessor: row  => {
                    return (
                        <div>{TableConfig.truncateCellStyle(row.mail)}</div>
                    );
                }
            },
            {
                header: 'Security Level',
                sort: true,
                column: 'securityLevel',
                className: 'security-level-column p-b vertical-align',
                accessor: row  => {
                    return (
                        <PillsDynamic
                                pillList={[row.securityLevel]}
                                className={`${secLevelColor[row.securityLevel]} border-corner-radius-rounding-08 p-i-04 p-b-02`}
                                handleEdit={null}
                                customIcon={null}
                        />
                    );
                }
            },
            {
                header: 'Company/Organization',
                sort: true,
                column: 'company',
                className: 'company-column p-b vertical-align',
                accessor: row => {
                    return (
                        <div>{row.company ? row.company : ''}</div>
                    );
                }
            },
            {
                header: 'Team',
                sort: true,
                column: 'team_membership',
                className: 'team-column p-b vertical-align',
                accessor: row => {
                    let teamDisplay = '';
                    if (row.team_membership) {
                        if (Array.isArray(row.team_membership)) {
                            teamDisplay = row.team_membership.join(', ');
                        } else if (typeof row.team_membership === 'string') {
                            teamDisplay = row.team_membership;
                        } else {
                            teamDisplay = String(row.team_membership);
                        }
                    }
                    return (
                        <div>{teamDisplay}</div>
                    );
                }
            },
            {
                header: 'Last Login',
                sort: true,
                column: 'last_login',
                className: 'last-login-column p-b vertical-align',
                accessor: row => {
                    let lastLoginDate = '';
                    try {
                        if (row.last_login) {
                            lastLoginDate = row.last_login;
                        } else if (row.lastLogin && Array.isArray(row.lastLogin) && row.lastLogin.length > 0 && row.lastLogin[0].DateOfLogin) {
                            lastLoginDate = row.lastLogin[0].DateOfLogin;
                        }               
                        
                        if (lastLoginDate) {
                            return <div>{dayjs(lastLoginDate).format('MM/DD/YYYY')}</div>;
                        }
                    } catch (error) {
                        console.error('Error formatting last login date:', error);
                    }
                    return <div>{'—'}</div>;
                }
            },
            {
                header: 'User Created Date',
                sort: true,
                column: 'created_at',
                className: 'created-date-column p-b vertical-align',
                accessor: row => {
                    try {
                        if (row.created_at) {
                            return <div>{dayjs(row.created_at).format('MM/DD/YYYY')}</div>;
                        }
                    } catch (error) {
                        console.error('Error formatting created date:', error);
                    }
                    return <div>{'—'}</div>;
                }
            },
            {
                header: 'Default Workspace',
                sort: true,
                column: 'defaultWorkspaceID',
                className: 'default-workspace-column p-b vertical-align',
                accessor: row => {
                    const workspaceId = row.defaultWorkspaceID || row.defaultWkspc || '';
                    const displayValue = TableConfig.truncateCellStyle(String(workspaceId));
                    return (
                        <div>{displayValue}</div>
                    );
                }
            },
            {
                header: 'Migrated',
                sort: false,
                column: 'migrated',
                className: 'migrated-column p-b vertical-align',
                accessor: row => {
                    return (
                        <div className="text-center">{row.migrated ? null: <RecordFill style={{color: '#C8303F'}}/>}</div>
                    );
                }
            }
        ];
    },

    //Global User List Table Config can be added here in future
    'GLOBAL_USERLIST_SETTINGS_CONFIG': () => {
        let secLevelColor = {
            '1': 'b-w-500',
            '2': 'blue-600',
            '3': 'blue-400',
            '4': 'green-300',
            '5': 'green-500',
            '6': 'orange-500'
        }

        return [
            {
                header: 'Name',
                sort: true,
                column: 'displayName',
                className: 'user-column p-b vertical-align truncate-cell',
                accessor: row  => {
                    return (
                        <div>{TableConfig.truncateCellStyle(row.displayName)}</div>
                    );
                }
            },
            {
                header: 'Email',
                sort: true,
                column: 'mail',
                className: 'email-column p-b vertical-align truncate-cell',
                accessor: row  => {
                    return (
                        <div>{TableConfig.truncateCellStyle(row.mail)}</div>
                    );
                }
            },
            {
                header: 'Security Level',
                sort: true,
                column: 'securityLevel',
                className: 'security-level-column p-b vertical-align',
                accessor: row  => {
                    return (
                        <PillsDynamic
                                pillList={[row.securityLevel]}
                                className={`${secLevelColor[row.securityLevel]} border-corner-radius-rounding-08 p-i-04 p-b-02`}
                                handleEdit={null}
                                customIcon={null}
                        />
                    );
                }
            },
            {
                header: 'Last Login',
                sort: true,
                column: 'last_login',
                className: 'last-login-column p-i-04 p-b vertical-align',
                accessor: row => {
                    let lastLoginDate = '';
                    try {
                        if (row.last_login) {
                            lastLoginDate = row.last_login;
                        } else if (row.lastLogin && Array.isArray(row.lastLogin) && row.lastLogin.length > 0 && row.lastLogin[0].DateOfLogin) {
                            lastLoginDate = row.lastLogin[0].DateOfLogin;
                        }
                        
                        if (lastLoginDate) {
                            return <div>{dayjs(lastLoginDate).format('MM/DD/YYYY')}</div>;
                        }
                    } catch (error) {
                        console.error('Error formatting last login date:', error);
                    }
                    return <div>{'—'}</div>;
                }
            },
            {
                header: 'Company/Organization',
                sort: true,
                column: 'company',
                className: 'company-column p-b vertical-align',
                accessor: row => {
                    return (
                        <div>{row.company ? row.company : ''}</div>
                    );
                }
            },
            {
                header: 'Team',
                sort: true,
                column: 'team_membership',
                className: 'team-column p-b vertical-align',
                accessor: row => {
                    let teamDisplay = '';
                    if (row.team_membership) {
                        if (Array.isArray(row.team_membership)) {
                            teamDisplay = row.team_membership.join(', ');
                        } else if (typeof row.team_membership === 'string') {
                            teamDisplay = row.team_membership;
                        } else {
                            teamDisplay = String(row.team_membership);
                        }
                    }
                    return (
                        <div>{teamDisplay}</div>
                    );
                }
            },
            {
                header: 'User Comments',
                sort: false,
                column: 'comments',
                className: 'comments-column p-b vertical-align',
                accessor: row => {
                    return (
                        <div className="text-center">{row.comments ? row.comments : ''}</div>
                    );
                }
            },
            {
                header: 'Migrated',
                sort: false,
                column: 'migrated',
                className: 'migrated-column p-b vertical-align',
                accessor: row => {
                    return (
                        <div className="text-center">{row.migrated ? null: <RecordFill style={{color: '#C8303F'}}/>}</div>
                    );
                }
            },
            {
                header: 'Default Workspace',
                sort: true,
                column: 'defaultWorkspaceID',
                className: 'default-workspace-column p-b vertical-align',
                accessor: row => {
                    const workspaceId = row.defaultWorkspaceID || row.defaultWkspc || '';
                    const displayValue = TableConfig.truncateCellStyle(String(workspaceId));
                    return (
                        <div>{displayValue}</div>
                    );
                }
            },
            {
                header: 'User Created Date',
                sort: true,
                column: 'created_at',
                className: 'created-date-column p-b vertical-align',
                accessor: row => {
                    let createdDate = '';
                    try {
                        if (row.created_at) {
                            createdDate = row.created_at;
                        } else if (row.createdAt) {
                            createdDate = row.createdAt;
                        }
                        if (createdDate) {
                            return <div>{dayjs(createdDate).format('MM/DD/YYYY')}</div>;
                        }
                    } catch (error) {
                        console.error('Error formatting created date:', error);
                    }
                    return <div>{'—'}</div>;
                }
            }
        ];
    },

    'VPOP_TABLE_CONFIG': () => {
        return [
            {   
                header: 'Discretionary/Guaranteed',
                sort: false,
                column: 'cvb_category',
                className: 'discretionary-guaranteed-column p-b vertical-align pl-0',
                accessor: row => {
                    return (
                        <div>{row.cvb_category ? row.cvb_category : ''}</div>
                    );
                }
            },
            {   
                header: 'Vaccine',
                sort: false,
                column: 'vaccine',
                className: 'vaccine-column p-b vertical-align',
                accessor: row => {
                    return (
                        <div>{row.vaccine ? row.vaccine : ''}</div>
                    );
                }
            },
            {   
                header: 'Routine/Campaign',
                sort: false,
                column: 'type',
                className: 'type-column p-b vertical-align',
                accessor: row => {
                    return (
                        <div>{row.type ? row.type : ''}</div>
                    );
                }
            },
            {   
                header: 'Scenario',
                sort: false,
                column: 'scenario',
                className: 'scenario-column p-b vertical-align',
                accessor: row => {
                    return (
                        <div>{row.scenario ? row.scenario : ''}</div>
                    );
                }
            },
            {   
                header: 'Year',
                sort: false,
                column: 'year',
                className: 'year-column p-b vertical-align',
                accessor: row => {
                    return (
                        <div>{row.year ? row.year : ''}</div>
                    );
                }
            },
            {   
                header: 'TRS',
                sort: false,
                column: 'trs',
                className: 'trs-column p-b vertical-align',
                accessor: row => {
                    return (
                        <div>{row.trs ? Math.round(row.trs).toLocaleString() : ''}</div>
                    );
                }
            },
            {   
                header: 'Cost to Gavi',
                sort: false,
                column: 'cost_to_gavi',
                className: 'cost-to-gavi-column p-b vertical-align',
                accessor: row => {
                    return (
                        <div>{row.cost_to_gavi ? `$${Math.round(row.cost_to_gavi).toLocaleString()}` : ''}</div>
                    );
                }
            },
            {   
                header: 'Cost to Country',
                sort: false,
                column: 'cost_to_country',
                className: 'cost-to-country-column p-b vertical-align',
                accessor: row => {
                    return (
                        <div>{row.cost_to_country ? `$${Math.round(row.cost_to_country).toLocaleString()}` : ''}</div>
                    );
                }
            },
        ]
    }

};

export default TableConfig;
